import { service } from '@ember/service';
import Component from '@glimmer/component';
import type IntlService from 'ember-intl/services/intl';
import config from 'frontend/config/environment';

interface Schools {
  href: string;
  src: string;
  width: string;
  alt: string;
}

export default class FooterSchoolsComponent extends Component {
  @service declare intl: IntlService;

  get wpUrl() {
    return config.wpUrl;
  }

  get schools(): Schools[] {
    return [
      {
        href: 'https://www.leforem.be/',
        src: `${this.wpUrl}/wp-content/uploads/2023/04/forem.png`,
        width: 'w-[88px]',
        alt: this.intl.t('components.footer.schools.alt_forem'),
      },
      {
        href: 'https://uclouvain.be/fr/index.html',
        src: `${this.wpUrl}/wp-content/uploads/2023/04/ucl-1024x238.png`,
        width: 'w-[190px]',
        alt: this.intl.t('components.footer.schools.alt_ucl'),
      },
      {
        href: 'https://www.cetic.be/',
        src: `${this.wpUrl}/wp-content/uploads/2023/04/cetic.png`,
        width: 'w-[113px]',
        alt: this.intl.t('components.footer.schools.alt_cetic'),
      },

      {
        href: 'https://www.agoria.be/fr',
        src: `${this.wpUrl}/wp-content/uploads/2023/04/agoria-1024x315.png`,
        width: 'w-[113px]',
        alt: this.intl.t('components.footer.schools.alt_agoria'),
      },
      {
        href: 'https://www.ulb.be/',
        src: `${this.wpUrl}/wp-content/uploads/2023/04/ulb-1024x1024.png`,
        width: 'w-[63px]',
        alt: this.intl.t('components.footer.schools.alt_ulb'),
      },
      {
        href: 'https://www.setca.org/fr/fed/home',
        src: `${this.wpUrl}/wp-content/uploads/2023/04/setca.png`,
        width: 'w-[140px]',
        alt: this.intl.t('components.footer.schools.alt_setca'),
      },
      {
        href: 'https://www.lacsc.be/cne',
        src: `${this.wpUrl}/wp-content/uploads/2023/04/cne.png`,
        width: 'w-[106px]',
        alt: this.intl.t('components.footer.schools.alt_cne'),
      },
    ];
  }
}
